// Public-facing config — single source of truth for env-driven values that
// need to render in the UI (vs backend-only config that lives in
// `backend/app/config.py`).
//
// Per user feedback on 2026-09-27 (W35.5 follow-up issue #2):
//   "邀請連結在dev mode下用localhost,用戶可在env下設置 domain
//    現時顯示是失效的" — invitation links used to hardcode
//   `window.location.origin` which renders `http://localhost:5173`
//   in dev — useless when the recipient is on a real device.
//
// The fix:
//   1. `getPublicUrl()` reads `import.meta.env.VITE_PUBLIC_URL` and
//      falls back to `window.location.origin` if unset.
//   2. PairInvitePage + every `ShareSheet` consumer use this helper.
//
// `.env.example` documents the new variable.

export function getPublicUrl(): string {
  const fromEnv = import.meta.env.VITE_PUBLIC_URL;
  if (typeof fromEnv === "string" && fromEnv.length > 0) {
    return fromEnv.replace(/\/$/, ""); // strip trailing slash
  }
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "";
}